import { Box, Typography } from "@mui/material";

export const getQuestions = (t) => {
  return {
    "Teil 1/6": {
      questions: [
        {
          id: "0-1",
          type: "likert",
          question: {
            de: "Insgesamt betrachtet: Haben Sie durch die Nutzung der Webseite neue Informationen erhalten, die Sie vorher noch nicht hatten?",
            tr: "Genel olarak: Web sitesini kullanarak daha önce sahip olmadığınız yeni bilgiler edindiniz mi?",
            pl: "Ogólnie: Czy dzięki korzystaniu ze strony internetowej uzyskałeś nowe informacje, których nie miałeś wcześniej?",
          },
        },
        {
          id: "0-2",
          type: "single",
          question: {
            de: "Welche Inhalte der Webseite sind für Sie am interessantesten?",
            tr: "Web sitesinin hangi içerikleri sizin için en ilgi çekici?",
            pl: "Które treści na stronie są dla Ciebie najciekawsze?",
          },
          choices: [{'de': 'Quizze', 'tr': 'Sınavlar', 'pl': 'Quizy'}, {'de': 'Filme', 'tr': 'Filmler', 'pl': 'Filmy'}, 
          {'de': 'Interaktive Comics', 'tr': 'İnteraktif çizgi romanlar', 'pl': 'Komiksy interaktywne'}],
        },
        {
          id: "0-3",
          type: "single",
          question: {
            de: "Welche Inhalte der Webseite sind für Sie am wenigsten interessant?",
            tr: "Web sitesinin hangi içeriği sizin için en az ilgi çekici?",
            pl: "Które treści na stronie są dla Ciebie najmniej interesujące?",
          },
          choices: [{'de': 'Quizze', 'tr': 'Sınavlar', 'pl': 'Quizy'}, {'de': 'Filme', 'tr': 'Filmler', 'pl': 'Filmy'}, {'de': 'Interaktive Comics', 'tr': 'İnteraktif çizgi romanlar', 'pl': 'Komiksy interaktywne'}],
        },
        {
          id: "0-4",
          type: "text",
          question: {
            de: "Welche weiteren Inhalte, die es aktuell noch nicht auf der Webseite gibt, wären für Sie interessant?",
            tr: "Şu anda web sitesinde olmayan başka hangi içerikler sizin için ilginç olurdu?",
            pl: "Jakie inne treści, których nie ma obecnie na stronie, byłyby dla Ciebie interesujące?",
          },
        },
        {
          id: "0-5",
          type: "single_filter",
          question: {
            de: "Können Sie sich vorstellen, die Webseite an andere Personen weiterzuempfehlen?",
            tr: "Bu web sitesini başkalarına tavsiye ettiğinizi hayal edebiliyor musunuz?",
            pl: "Czy wyobrażasz sobie polecenie strony innym osobom?",
          },
          choices: [
            { choice: {'de': 'Ja', 'tr': 'Ja', 'pl': 'Ja'}, filterId: "0-5-1" },
            { choice: {'de': 'Nein', 'tr': 'Hayır', 'pl': 'Nie'}, filterId: "0-5-2" },
            { choice: {'de': 'Eventuell', 'tr': 'Muhtemelen', 'pl': 'Ewentualnie'}, filterId: "0-5-1" },
          ],
          filtered: [
            {
              id: "0-5-1",
              type: "multi_free",
              question:{
                de: "Aus welchen Gründen würden Sie die Webseite an andere Personen weiterempfehlen?",
                tr: "Hangi nedenlerden dolayı web sitesini başkalarına tavsiye edersiniz?",
                pl: "Z jakich powodów poleciłbyś tę stronę innym?",
              },
              choices: [
                {'de': 'Weil sie ihnen Informationen bietet, die sie ansonsten nicht erhalten würden', 'tr': 'Çünkü onlara başka türlü alamayacakları bilgiler sunuyor', 'pl': 'Ponieważ oferuje im informacje, których nie otrzymaliby w innym przypadku'},
                {'de': 'Weil die Informationen auf eine unterhaltsame Weise vermittelt werden', 'tr': 'Çünkü bilgi eğlenceli bir şekilde aktarılıyor', 'pl': 'Ponieważ informacje są przekazywane w zabawny sposób'},
                {'de': 'Weil die Informationen auf eine verständliche Weise vermittelt werden ', 'tr': 'Çünkü bilgiler anlaşılabilir bir şekilde aktarılıyor', 'pl': 'Ponieważ informacje są przekazywane w sposób zrozumiały'},
                {'de': 'Weil es Spaß macht, die App zu nutzen', 'tr': 'Çünkü uygulamayı kullanmak eğlenceli', 'pl': 'Ponieważ korzystanie z aplikacji jest przyjemne'},
                {'de': '', 'tr': '', 'pl': ''},
              ],
            },
            {
              id: "0-5-2",
              type: "multi_free",
              question:{
                de: "Wieso würden Sie die Webseite nicht an andere Personen weiterempfehlen?",
                tr: "Web sitesini neden başkalarına tavsiye etmiyorsunuz?",
                pl: "Dlaczego nie poleciłbyś tej strony innym osobom?",
              },
              choices: [
                {'de': 'Weil sie keine relevanten Informationen enthält', 'tr': 'Çünkü ilgili bilgileri içermiyor', 'pl': 'Ponieważ nie zawiera on istotnych informacji'},
                {'de': 'Weil sie keine neuen Informationen enthält', 'tr': 'Yeni bir bilgi içermediği için', 'pl': 'Ponieważ nie zawiera żadnych nowych informacji'},
                {'de': 'Weil die Informationen auch aus anderen Quellen bezogen werden können', 'tr': 'Çünkü bilgi başka kaynaklardan da elde edilebilir', 'pl': 'Ponieważ informacje te można uzyskać również z innych źródeł'},
                {'de': 'Weil die Nutzung zu umständlich ist', 'tr': 'Çünkü kullanımı çok zahmetli', 'pl': 'Ponieważ użycie jest zbyt kłopotliwe'},
                {'de': 'Weil die Webseite nicht ansprechend gestaltet ist', 'tr': 'Web sitesi çekici bir şekilde tasarlanmadığı için', 'pl': 'Ponieważ strona nie jest atrakcyjnie zaprojektowana'},
                {'de': '', 'tr': '', 'pl': ''},
              ],
            },
          ],
        },
      ],
    },
    "Teil 2/6": {
      questions: [
        {
          id: "1-1",
          type: "likert",
          question: {
            de: "Ich bin insgesamt zufrieden damit, wie einfach die Nutzung der Webseite ist.",
            tr: "Genel olarak, web sitesini kullanmanın bu kadar kolay olmasından memnunum.",
            pl: "Ogólnie jestem zadowolony z tego, jak łatwo jest korzystać ze strony.",
          },
        },
        {
          id: "1-2",
          type: "likert",
          question: {
            de: "Ich finde die bereitgestellten Informationen verständlich.",
            tr: "Verilen bilgileri anlaşılabilir buluyorum.",
            pl: "Uważam, że podane informacje są zrozumiałe.",
          },
        },
        {
          id: "1-3",
          type: "likert",
          question: {
            de: "Ich kann Informationen, die ich suche leicht finden.",
            tr: "Aradığım bilgiyi kolayca bulabiliyorum.",
            pl: "Łatwo mogę znaleźć informacje, których szukam.",
          },
        },
        {
          id: "1-10",
          type: "likert",
          question: {
            de: "Es gefällt mir, dass ich mit 'Sie' angesprochen werde.",
            tr: "Bana 'sen' diye hitap edilmesinden hoşlanıyorum.",
            pl: 'Lubię, gdy zwraca się do mnie per "ty".',
          },
        },
        {
          id: "1-4",
          type: "likert",
          question: {
            de: "Ich fand es einfach zu verstehen, wie ich die Webseite nutzen kann.",
            tr: "Web sitesinin nasıl kullanılacağını anlamayı kolay buldum.",
            pl: "Łatwo było mi zrozumieć, jak korzystać ze strony internetowej.",
          },
        },
        {
          id: "1-5",
          type: "likert",
          question: {
            de: "Ich konnte die Hinweise und Tipps leicht nachvollziehen.",
            tr: "İpuçlarını ve tavsiyeleri kolayca takip edebildim.",
            pl: "Z łatwością mogłam zastosować się do wskazówek i podpowiedzi.",
          },
        },
        {
          id: "1-6",
          type: "likert",
          question: {
            de: "Ich finde das Aussehen der Webseite ansprechend.",
            tr: "Web sitesinin görünümünü çekici buluyorum.",
            pl: "Uważam, że wygląd strony jest atrakcyjny.",
          },
        },
        {
          id: "1-7",
          type: "likert",
          question: {
            de: "Die Webseite hatte alle Funktionen und Angebote, die ich erwartet habe.",
            tr: "Web sitesi beklediğim tüm özelliklere ve tekliflere sahipti.",
            pl: "Strona miała wszystkie funkcje i oferty, których oczekiwałem.",
          },
        },
        {
          id: "1-8",
          type: "likert",
          question: {
            de: "Ich finde die Webseite insgesamt ansprechend.",
            tr: "Web sitesini genel olarak çekici buluyorum.",
            pl: "Ogólnie rzecz biorąc, uważam, że strona jest atrakcyjna.",
          },
        },
        {
          id: "1-9",
          type: "likert",
          question: {
            de: "Ich könnte mir vorstellen, die Webseite regelmäßig zu nutzen",
            tr: "Web sitesini düzenli olarak kullanmayı hayal edebiliyorum",
            pl: "Mógłbym sobie wyobrazić regularne korzystanie z tej strony",
          },
        },
      ],
    },
    "Teil 3/6": {
      questions: [
        {
          id: "2-1",
          type: "likert",
          question: {
            de: "Die Webseite hat mich motiviert, Fortschritt zu machen und besser zu werden.",
            tr: "Web sitesi beni ilerleme kaydetmek ve daha iyi olmak için motive etti.",
            pl: "Strona zmotywowała mnie do robienia postępów i stawania się lepszym.",
          },
        },
        {
          id: "2-2",
          type: "likert",
          question: {
            de: "Die Webseite hat mir das Gefühl gegeben, dass ich ein klares Ziel habe.",
            tr: "Web sitesi bana net bir hedefim olduğunu hissettirdi.",
            pl: "Strona dała mi poczucie, że mam jasno określony cel.",
          },
        },
        {
          id: "2-3",
          type: "likert",
          question: {
            de: "Die Webseite hat mir das Gefühl gegeben, dass ich Ziele erreichen muss.",
            tr: "Web sitesi bana hedeflerime ulaşmam gerektiği hissini verdi.",
            pl: "Strona dała mi poczucie, że muszę osiągać cele.",
          },
        },
        {
          id: "2-4",
          type: "likert",
          question: {
            de: "Die Webseite hat mich herausgefordert.",
            tr: "Web sitesi bana meydan okudu.",
            pl: "Strona rzuciła mi wyzwanie.",
          },
        },
        {
          id: "2-5",
          type: "likert",
          question: {
            de: "Die Webseite hat mir das Gefühl gegeben, geleitet zu werden.",
            tr: "Web sitesi bana rehberlik ettiğini hissettirdi.",
            pl: "Strona sprawiła, że poczułam się poprowadzona.",
          },
        },
        {
          id: "2-6",
          type: "likert",
          question: {
            de: "Die Webseite hat mir das Gefühl gegeben, dass mich jemand auf Kurs hält.",
            tr: "Web sitesi bana birilerinin beni takip ettiğini hissettirdi.",
            pl: "Strona internetowa sprawiła, że poczułem, że ktoś trzyma mnie na wodzy.",
          },
        },
        {
          id: "2-7",
          type: "likert",
          question: {
            de: "Die Webseite zeigt mir klar auf, was ich tun muss, um mich zu verbessern",
            tr: "Web sitesi bana kendimi geliştirmek için ne yapmam gerektiğini açıkça gösteriyor",
            pl: "Strona jasno pokazuje mi, co muszę zrobić, aby się poprawić",
          },
        },
        {
          id: "2-8",
          type: "likert",
          question: {
            de: "Die Webseite gibt mir hilfreiches Feedback, um mich zu verbessern",
            tr: "Web sitesi kendimi geliştirmem için bana yararlı geri bildirimler veriyor",
            pl: "Strona daje mi pomocne informacje zwrotne, dzięki którym mogę się doskonalić",
          },
        },
        {
          id: "2-9",
          type: "likert",
          question: {
            de: "Die Webseite zieht meine Aufmerksamkeit auf sich",
            tr: "Web sitesi dikkatimi çekti",
            pl: "Strona przykuwa moją uwagę",
          },
        },
        {
          id: "2-10",
          type: "likert",
          question: {
            de: "Während ich die Webseite nutze, verfliegt die Zeit.",
            tr: "Web sitesini kullanırken zaman uçup gidiyor.",
            pl: "Podczas gdy korzystam ze strony internetowej, czas leci.",
          },
        },
        {
          id: "2-11",
          type: "likert",
          question: {
            de: "Die Webseite gibt mir Raum, spontan zu sein.",
            tr: "Web sitesi bana spontane olmam için alan sağlıyor.",
            pl: "Strona daje mi przestrzeń do bycia spontanicznym.",
          },
        },
        {
          id: "2-12",
          type: "likert",
          question: {
            de: "Die Webseite gibt mir das Gefühl, dass ich neue Dinge entdecke.",
            tr: "Web sitesi bana yeni şeyler keşfediyormuşum gibi hissettiriyor.",
            pl: "Dzięki stronie czuję, że odkrywam nowe rzeczy.",
          },
        },
        {
          id: "2-13",
          type: "likert",
          question: {
            de: "Die Webseite gibt mir das Gefühl, dass ich wissen möchte, was als nächstes kommt.",
            tr: "Web sitesi, bir sonraki adımda ne olacağını bilmek istediğimi hissettiriyor.",
            pl: "Strona sprawia, że chcę wiedzieć, co będzie dalej.",
          },
        },
        {
          id: "2-14",
          type: "likert",
          question: {
            de: "Während ich die Webseite nutze, habe ich das Gefühl, dass ich nicht alleine bin.",
            tr: "Web sitesini kullanırken yalnız olmadığımı hissediyorum.",
            pl: "Korzystając z serwisu mam wrażenie, że nie jestem sama.",
          },
        },
        {
          id: "2-15",
          type: "likert",
          question: {
            de: "Die Webseite gibt mir ein Gefühl von sozialer Unterstützung.",
            tr: "Web sitesi bana bir sosyal destek hissi veriyor.",
            pl: "Strona daje mi poczucie wsparcia społecznego.",
          },
        },
        {
          id: "2-16",
          type: "likert",
          question: {
            de: "Die Webseite fühlt sich wie eine soziale Erfahrung an.",
            tr: "Web sitesi sosyal bir deneyim gibi hissettiriyor.",
            pl: "Strona internetowa sprawia wrażenie doświadczenia społecznego.",
          },
        },
        {
          id: "2-17",
          type: "likert",
          question: {
            de: "Die Webseite gibt mir das Gefühl, für das was ich geschafft habe, beachtet zu werden.",
            tr: "Web sitesi bana başardıklarımın fark edildiği hissini veriyor.",
            pl: "Strona daje mi poczucie, że jestem zauważony za to, co osiągnąłem.",
          },
        },
      ],
    },
    "Teil 4/6": {
      questions: [
        {
          id: "3-1",
          type: "opposite",
          left: { de: "behindernd", tr: "obstrüktif", pl: "obstrukcyjny" },
          right: { de: "unterstützend", tr: "destekleyici", pl: "wspieranie" },
        },
        {
          id: "3-2",
          type: "opposite",
          left: { de: "kompliziert", tr: "karmaşık", pl: "skomplikowane" },
          right: { de: "einfach", tr: "basitçe", pl: "po prostu" },
        },
        {
          id: "3-3",
          type: "opposite",
          left: { de: "ineffizient", tr: "verimsiz", pl: "nieskuteczne" },
          right: { de: "effizient", tr: "verimli", pl: "sprawny" },
        },
        {
          id: "3-4",
          type: "opposite",
          left: { de: "verwirrend", tr: "Kafa karıştırıcı", pl: "mylące" },
          right: { de: "übersichtlich", tr: "açıkça", pl: "wyraźnie" },
        },
        {
          id: "3-5",
          type: "opposite",
          left: { de: "langweilig", tr: "sıkıcı", pl: "nudny" },
          right: { de: "spannend", tr: "heyecan verici", pl: "ekscytujące" },
        },
        {
          id: "3-6",
          type: "opposite",
          left: {
            de: "uninteressant",
            tr: "ilgi çekici değil",
            pl: "nieciekawy",
          },
          right: { de: "interessant", tr: "ilginç", pl: "interessant" },
        },
        {
          id: "3-7",
          type: "opposite",
          left: { de: "konventionell", tr: "geleneksel", pl: "konwencjonalny" },
          right: { de: "originell", tr: "originell", pl: "originell" },
        },
        {
          id: "3-8",
          type: "opposite",
          left: { de: "herkömmlich", tr: "geleneksel", pl: "konwencjonalny" },
          right: { de: "neuartig", tr: "roman", pl: "powieść" },
        },
      ],
      text: (
        <Box sx={{ width: "100%", m: 0 }}>
          <Typography align="left">
            {t("surveyOppositeText1")}
          </Typography>
          <br />
          <Typography align="left">
            {t("surveyOppositeText2")}
          </Typography>
          <br />
          <Typography align="left">
            {t("surveyOppositeText3")}
          </Typography>
          <br />
          <Typography>{t("surveyOppositeText4")}</Typography>
        </Box>
      ),
    },
    "Teil 5/6": {
      questions: [
        {
          id: "4-1",
          type: "text",
          question: {
            de: "Wenn es noch etwas gibt, das Sie uns gerne mitteilen möchten, können Sie das hier gerne tun.",
            tr: "Bizimle paylaşmak istediğiniz başka bir şey varsa, lütfen buradan paylaşmaktan çekinmeyin.",
            pl: "Jeśli jest coś jeszcze, czym chcielibyście się z nami podzielić, zapraszamy tutaj.",
          },
        },
      ],
    },
    "Teil 6/6": {
      text: (
        <Box>
          <Typography align="left">
            {t("surveyFinalText1")}
          </Typography>
          <br />
        </Box>
      ),
      questions: [
        {
          id: "5-1",
          type: "single",
          question: { de: "Geschlecht", tr: "Cinsiyet", pl: "Płeć" },
          choices: [{'de': 'männlich', 'tr': 'erkek', 'pl': 'mężczyzna'}, {'de': 'weiblich', 'tr': 'kadın', 'pl': 'kobieta'}, {'de': 'divers', 'tr': 'dalgıçlar', 'pl': 'nurkowie'}],
        },
        {
          id: "5-2",
          type: "single",
          question: { de: "Alter", tr: "Yaş", pl: "Wiek" },
          choices: [
            {'de': 'unter 20', 'tr': '20 yaş altı', 'pl': 'poniżej 20'},
            {'de': '20 bis unter 25', 'tr': '20 ila 25 yaş altı', 'pl': '20 do poniżej 25'},
            {'de': '25 bis unter 30', 'tr': '25 ila 30 yaş altı', 'pl': '25 do poniżej 30'},
            {'de': '30 bis unter 35', 'tr': '30 ila 35 yaş altı', 'pl': '30 do poniżej 35'},
            {'de': '35 bis unter 40', 'tr': '35 ila 40 yaş altı', 'pl': '35 do poniżej 40'},
            {'de': '40 bis unter 45', 'tr': '40 ila 45 yaş altı', 'pl': '40 do poniżej 45'},
            {'de': '45 bis unter 50', 'tr': '45 ila 50 yaş altı', 'pl': '45 do poniżej 50'},
            {'de': '50 bis unter 55', 'tr': '50 ila 55 yaş altı', 'pl': '50 do poniżej 55'},
            {'de': '55 bis unter 60', 'tr': '55 ila 60 yaş altı', 'pl': '55 do poniżej 60'},
            {'de': '60 bis unter 65', 'tr': '60 ila 65 yaş altı', 'pl': '60 do poniżej 65'},
            {'de': '65 und älter', 'tr': '65 yaş ve üstü', 'pl': '65 lat i więcej'},
          ],
        },
        {
          id: "5-3",
          type: "single",
          question: {
            de: "Ich bin aktuell als Haushaltshilfe im/in Privathaushalt(en) tätig",
            tr: "Şu anda özel ev(ler)de ev yardımcısı olarak çalışıyorum",
            pl: "Obecnie pracuję jako pomoc domowa w prywatnym gospodarstwie (gospodarstwach domowych)",
          },
          choices: [{'de': 'Ja', 'tr': 'Ja', 'pl': 'Ja'}, {'de': 'Nein', 'tr': 'Hayır', 'pl': 'Nie'}],
        },
        {
          id: "5-4",
          type: "single",
          question: {
            de: "Ich bin aktuell Auftraggeber*in für haushaltsnahe Dienstleistungen",
            tr: "Şu anda evle ilgili hizmetler için bir müşteriyim",
            pl: "Jestem obecnie klientem usług związanych z prowadzeniem gospodarstwa domowego",
          },
          choices: [{'de': 'Ja', 'tr': 'Ja', 'pl': 'Ja'}, {'de': 'Nein', 'tr': 'Hayır', 'pl': 'Nie'}],
        },
        {
          id: "5-5",
          type: "single",
          question: {
            de: "Ich beschäftige mich beruflich mit Angestellten und Auftraggeber*innen in privaten Haushalten.",
            tr: "Ich beschäftige mich beruflich mit Angestellten und Auftraggeber*innen in privaten Haushalten.",
            pl: "Ich beschäftige mich beruflich mit Angestellten und Auftraggeber*innen in privaten Haushalten.",
          },
          choices: [{'de': 'Ja', 'tr': 'Ja', 'pl': 'Ja'}, {'de': 'Nein', 'tr': 'Hayır', 'pl': 'Nie'}],
        }
      ],
    },
  };
};
